import { render, staticRenderFns } from "./config.vue?vue&type=template&id=ce90a2ce"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce90a2ce')) {
      api.createRecord('ce90a2ce', component.options)
    } else {
      api.reload('ce90a2ce', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=ce90a2ce", function () {
      api.rerender('ce90a2ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/7-3-pop-icon-1/config.vue"
export default component.exports